export const habaCommon = {
  pageHero: {
    sideTitle: 'Sur cette page',
  },
  habaSearch: {
    placeholder: 'Cherche',
    showMore: 'Voir plus',
    home: "Page d'accueil",
    searchSuggestions: 'Suggestions de recherche',
    searchHistory: 'Ton historique de recherche',
    clearHistory: 'Supprimer',
    filterAndSort: 'Filtern & Sortieren',
    filters: {
      age: 'Âge',
      color: 'Couleur',
      brand: 'Marque',
      motives: 'Motif',
      more: 'Plus',
      price: 'Prix',
      collections: 'Collection',
      campaignTags: 'Campagne',
      genders: 'Genre',
      size: 'Taille',
      sizeSub: {
        appareal: 'Tailles de vêtements',
        belts: 'Tailles de ceinture',
        brassieres: 'Tailles de soutien-gorge',
        caps: 'Tailles de casquettes',
        gloves: 'Tailles de gants',
        shoes: 'Tailles de chaussures',
        specials: 'Tailles spéciales',
      },
      ageGroups: "Tranche d'âge",
      ageRange: "L'âge",
      productFunctions: 'Fonction',
      productFeatures: 'Propriété',
      materials: 'Matériel',
      sort: 'Trier',
      sortSub: {
        mostPopular: 'Plus populaires',
        new: 'Nouveautés',
        priceAsc: 'Prix le plus bas',
        priceDesc: 'Prix le plus élevé',
        rating: 'Meilleure note',
        sale: 'Vente',
      },
      sortBy: 'Trier par',
      categories: 'Autres catégories',
      reviews: 'Évaluation',
      show: 'Afficher',
      filter: 'Filtrer',
      resetAll: 'Réinitialiser tout',
      showMore: '+ Voir plus',
      showLess: '- Afficher moins',
      labels: {
        Babys: 'Bébé (0 - 18 mois)',
        Minis: 'Minis (1,5 - 5 ans)',
        Kids: 'Kids (5 - 7 ans)',
        Juniors: 'Juniors (à partir de 8 ans)',
        'keine Angabe': "pas d'indication",
        Junge: 'Jeune',
        Mädchen: 'Filles',
        unisex: 'Unisexe',
        Adults: 'Adulte',
        männlich: 'Homme',
        weiblich: 'Femme',
        0: "jusqu'à 1 an",
        1: 'à partir de 1 an',
        2: 'à partir de 2 ans',
        3: 'à partir de 3 ans',
        4: 'à partir de 4 ans',
        5: 'à partir de 5 ans',
        6: 'à partir de 6 ans',
        7: 'à partir de 7 ans',
        8: 'à partir de 8 ans',
        9: 'à partir de 9 ans',
        10: 'à partir de 10 ans',
        11: 'à partir de 11 ans',
        12: 'à partir de 12 ans',
      },
      salesFilter: 'Uniquement les offres spéciales',
      specialPrice: 'Offres spéciales',
      personalization: 'Oui',
    },
    noResults: {
      title: "Votre recherche pour {{state}} n'a donné aucun résultat.",
      subtitle:
        'Tu as peut-être fait une faute de frappe ? Essaie à nouveau avec un terme de recherche plus général.',
      inspiration: 'Ou laisse-toi inspirer ici!',
    },
  },
  habaNavigation: {
    showAll: 'Tout afficher',
    more: 'Plus',
    back: 'retour',
    allProducts: 'Tous les produits',
    topLinks: {
      contact: 'Contact',
    },
    showAllProducts: 'Voir tous les produits',
    shoppingCategories: "Catégories d'achats",
    mainEditorialCategories: 'Conseils et Inspiration',
    metaNavigationCategories: ' Service et Contact',
    showMore: 'Plus de catégories et de produits',
    chooseLand: 'Sélectionnez votre pays',
  },
  habaHttpHandlers: {
    notFound: '404 Page non trouvée',
    notAvailable: 'Page inaccessible',
    gone: "La ressource demandée n'est plus disponible",
    code: {
      alreadyRedeemed:
        'Le code promotionnel que vous avez saisi a déjà été échangé et ne peut pas être réutilisé.',
      expired: 'Le code promotionnel que vous avez saisi a déjà expiré.',
      unknownException: "Le numéro du bon n'est pas valable.",
      giftcardDisabled:
        "<strong>Nous sommes désolés !</strong> <br />Notre entreprise fait actuellement l'objet d'une procédure d'insolvabilité et d'auto-administration. <strong>Si votre carte cadeau a été achetée avant le 12.09.2023, le solde fait partie de la procédure et ne peut malheureusement pas être remboursé pour le moment.</strong> <br /> À partir du 01.12.2023, vous pourrez probablement enregistrer votre créance dans le tableau d'insolvabilité et la réclamer.",
      invalidCodeProvided:
        "Ce code de promotion n'est pas valide. Si vous avez d'autres questions, veuillez contacter notre équipe du service clientèle.",
      giftcardCommunicationError:
        "Pour des raisons techniques, il est temporairement impossible d'utiliser le bon.Merci de réessayer plus tard ou de contacter notre équipe du service clientèle.",
      giftcardErrorS4NotAvailable:
        'Malheureusement, les codes de réduction ne peuvent actuellement pas être utilisés pour des raisons techniques. Veuillez contacter notre service client.',
      giftcardInvalidBusinessModel:
        'Le numéro du bon ne peut pas être utilisé dans cette boutique en ligne.',
      giftcardInvalidBrand:
        'Le numéro du bon ne peut pas être utilisé dans cette boutique en ligne.',
      giftcardInvalidCurrency: "Le numéro de bon n'est pas autorisé pour cette monnaie.",
      giftcardAmount: 'Le bon a déjà été utilisé.',
      giftcardInvalid: "Ton bon d'achat a malheureusement expiré.",
      maximumQuantityReached:
        'Les quantités demandées ne sont plus disponibles. Quantités modifiées.',
      maximumQuantityReachedProductPage: 'Quantité maximale disponible atteinte',
      noEffectOnCart:
        "La valeur de votre commande n'atteint pas la valeur minimale de commande. Veuillez augmenter la valeur de votre commande et saisir à nouveau le code promotionnel.",
      noEffectOnCartWithoutCat:
        "Le code promotion est valable uniquement dans le cadre de l'achat de produits de la catégorie {{additionalMessage}} ou vérifier le montant de la valeur de commande.",
      noEffectOnCartWithoutPerso:
        "Le code promotionnel n'est valable que si votre commande contient un article personnalisé. Si le montant de votre commande n'atteint pas le minimum requis, veuillez augmenter le montant de votre commande et réintroduire le code promotionnel.",
    },
    registration: {
      successJakoo:
        '<strong>Votre compte a été activé.</strong> Vous pouvez vous connecter maintenant.',
      successJakooMobile:
        '<strong>Votre compte a été activé.</strong> <br /> Vous pouvez vous connecter maintenant.',
      successHaba:
        "<strong>Votre compte HABA est maintenant actif.</strong> Veuillez vous connecter à l'aide de vos données d'accès.",
      successHabaMobile:
        "<strong>Votre compte HABA est maintenant actif.</strong> <br /> Veuillez vous connecter à l'aide de vos données d'accès.",
      tokenExpired: 'Le jeton a expiré',
      invalidToken: 'Jeton invalide',
      customerNotFound: 'Client introuvable',
      genericError:
        "Désolé, cela n'a pas fonctionné. Veuillez vérifier que vous utilisez la bonne adresse e-mail et le bon mot de passe...",
    },
  },
  habaAuthentication: {
    success: 'Authentification réussie',
  },
  habaFooter: {
    contact: {
      retour: {
        headline: 'Retours & Formulaire de rétractation',
        description: 'Vous souhaitez annuler une commande ou retourner un article ?',
        button: 'Annuler la commande',
      },
    },
    info: {
      heading: 'Service clientèle',
      schedule: 'lundi - vendredi 08-18h',
      telephone: '0800 - 9564956',
      email: 'service@mail.com',
      contactForm: 'Formulaire de contact',
    },
    shop: {
      catalog: {
        headline: 'Notre catalogue',
        text1: 'Demander un catalogue gratuit',
        text2: 'Feuilleter en ligne',
      },
      payment: {
        headline: 'Nos modes de paiement',
      },
      secureShopping: {
        headline: 'Acheter en toute sécurité',
        text1: 'Paiement sécurisé avec cryptage SSL',
      },
      newsletter: {
        headline: 'Newsletter',
        text1: "Vers l'inscription",
        text2: 'Rester informé de toutes les offres, nouveautés & astuces de bricolage',
      },
    },
    serviceLinksHeader: 'Services et avantages',
    paymentMethodsHeader: 'Moyens de paiement et achats sécurisés',
    helpfulLinksHeader: 'Liens utiles',
    copyright:
      '© {{year}} - Habermaass GmbH & Co. KG et ses marques font partie du groupe Habermaass.',
    links: {
      service: {
        heading: 'Service',
        link1: 'Conseil sur place',
        link2: 'Contact',
        link3: 'FAQ',
        link4: 'Leasing',
        link5: 'Retour',
        link6: 'Certificats',
      },
      about: {
        heading: 'À propos de nous',
        link1: 'Événements',
        link2: 'Entreprise',
        link3: 'Emplois',
      },
    },
    meta: {
      link1: 'Contact',
      link2: 'Presse',
      link3: 'Information sur le droit de rétractation',
      link4: 'Formulaire de rétractation',
      link5: "Conseil pour l'élimination",
      link6: 'Infos légales',
      link7: 'CGV',
      link8: 'Protection des données',
      link9: 'Paramètres des cookies',
    },
    locale: {
      footerTitle: 'Sélection de pays et de langues',
      modalTitle: 'Choisis ton pays',
      country: 'Choisir un pays',
      language: 'Langue',
      message: 'Ton panier est vidé lorsque tu changes de pays.',
      submit: 'CONFIRMER LA SÉLECTION',
    },
  },
  habaDelivery: {
    packageOnTheWay: "Ton colis est en route vers toi ! Tu peux suivre l'envoi ici:",
  },
  footerNewsletter: {
    headline: 'Inscrivez-vous simplement à la newsletter et profitez-en en permanence.',
    email: {
      label: "Saisir l'adresse e-mail",
      error: 'Adresse e-mail invalide',
    },
    privacy: {
      label:
        'J\'accepte la politique de <a href="{{url}}" target="_blank"><u>confidentialité</u></a>.',
      error: 'Veuillez accepter la politique de confidentialité.',
    },
    submit: 'Abonnez-vous à la newsletter',
    submitError: "Désolé, ça n'a pas marché.",
  },
  habaExternalMessages: {
    'payment.error.default':
      'Un problème est survenu pendant la prise de contact avec le prestataire de paiement. Attends quelques minutes et réessaie ou choisis un autre mode de paiement. Si le problème persiste, contacte notre centre de service clientèle.',
  },
  countdownBanner: {
    label: 'Encore',
    days: 'Jour(s)',
    hours: 'heure(s)',
    minutes: 'mn',
    seconds: 'sec',
  },
};
